module.exports = __webpack_public_path__ + "static/media/ChevronUpDisabled.05363508.svg";